<template>
  <el-dialog
    :close-on-click-modal="false"
    title="快递追踪"
    :visible.sync="isShow"
    width="480px"
    custom-class="express-track-dialog"
  >
    <div class="express-body">
      <!-- 包裹标签 -->
      <div class="package-tabs">
        <span
          v-for="(pkg, idx) in packageList"
          :key="idx"
          class="tab-item"
          :class="{ active: activePackage === idx }"
          @click="activePackage = idx"
        >
          {{ pkg.name }}
        </span>
      </div>

      <!-- 快递信息头部 -->
      <div class="express-header">
        <span class="status-dot"></span>
        <span class="express-name">{{ shipperName }}</span>
        <span class="express-no">{{ LogisticCode }}</span>
      </div>

      <!-- 物流时间线 -->
      <div class="timeline-wrap">
        <div
          v-for="(item, index) in displayTraces"
          :key="index"
          class="timeline-item"
          :class="{ latest: index === 0 }"
        >
          <div class="timeline-marker">
            <span class="dot" :class="{ active: index === 0 }"></span>
            <span v-if="index !== traces.length - 1" class="line"></span>
          </div>
          <div class="timeline-content">
            <p class="status-title">{{ getStatusTitle(item.AcceptStation) }}</p>
            <p class="status-desc">{{ item.AcceptStation }}</p>
            <p class="status-time">{{ item.AcceptTime }}</p>
          </div>
        </div>
      </div>

      <!-- 查看更多 -->
      <div v-if="traces.length > 3 && !showAll" class="view-more" @click="showAll = true">
        <span>查看更多物流明细</span>
        <i class="el-icon-arrow-down"></i>
      </div>
      <div v-if="showAll && traces.length > 3" class="view-more" @click="showAll = false">
        <span>收起物流明细</span>
        <i class="el-icon-arrow-up"></i>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getExpressDetail } from '@/api/oms'

const SHIPPER_MAP = {
  ZTO: '中通快递',
  STO: '申通快递',
  YTO: '圆通速递',
  YD: '韵达速递',
  YZPY: '邮政快递包裹',
  EMS: 'EMS',
  JD: '京东快递',
  SF: '顺丰速运',
  DBL: '德邦快递'
}

export default {
  name: 'express-dialog',
  data () {
    return {
      isShow: false,
      expressPackages: [],
      activePackage: 0
    }
  },
  computed: {
    currentPackage () {
      return this.expressPackages[this.activePackage] || {}
    },
    packageList () {
      return this.expressPackages.map((_pkg, idx) => ({
        name: '包裹' + (idx + 1)
      }))
    },
    shipperName () {
      return SHIPPER_MAP[this.currentPackage.ShipperCode] || this.currentPackage.ShipperCode || ''
    },
    LogisticCode () {
      return this.currentPackage.LogisticCode || ''
    },
    traces () {
      return this.currentPackage.traces || []
    },
    showAll: {
      get () {
        return this.currentPackage.showAll || false
      },
      set (val) {
        if (this.currentPackage) {
          this.currentPackage.showAll = val
        }
      }
    },
    displayTraces () {
      if (this.showAll) return this.traces
      return this.traces.slice(0, 3)
    }
  },
  methods: {
    show (express, phone) {
      this.isShow = true
      this.activePackage = 0
      this.expressPackages = []
      const trackNoArr = typeof express.trackNo === 'string' ? express.trackNo.split(',') : [express.trackNo]
      let val = phone ? this.$msg.filterBridal(phone).substr(-4) : ''
      trackNoArr.forEach((trackNo) => {
        const pkg = { express: trackNo.trim(), traces: [], ShipperCode: '', LogisticCode: '', showAll: false }
        this.expressPackages.push(pkg)
        getExpressDetail({ shipperCode: express.shipperCode, trackNo: trackNo.trim() }, val).then(res => {
          let expressInfo = res.data.data
          pkg.traces = expressInfo.Traces.sort((a, b) => Date.parse(b.AcceptTime) - Date.parse(a.AcceptTime))
          pkg.ShipperCode = expressInfo.ShipperCode
          pkg.LogisticCode = expressInfo.LogisticCode
        })
      })
    },
    hide () {
      this.isShow = false
    },
    getStatusTitle (station) {
      if (station.includes('签收') || station.includes('已签收')) return '已签收'
      if (station.includes('派件') || station.includes('派送')) return '派送中'
      if (station.includes('运输') || station.includes('发往') || station.includes('离开')) return '运输中'
      if (station.includes('揽收')) return '已揽收'
      return '运输中'
    }
  }
}
</script>

<style lang="less" scoped>
.express-body {
  padding: 0 10px;
}

.package-tabs {
  margin-bottom: 20px;

  .tab-item {
    display: inline-block;
    padding: 6px 16px;
    border: 1px solid #dcdfe6;
    border-radius: 16px;
    font-size: 13px;
    color: #606266;
    cursor: pointer;
    margin-right: 10px;
    transition: all 0.2s;

    &.active {
      border-color: #67c23a;
      color: #67c23a;
      background: #f0f9eb;
    }
  }
}

.express-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #67c23a;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .express-name {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
  }

  .express-no {
    font-size: 14px;
    color: #303133;
    margin-left: 6px;
  }
}

.timeline-wrap {
  max-height: 360px;
  overflow-y: auto;
}

.timeline-item {
  display: flex;
  position: relative;
  padding-bottom: 20px;

  &.latest {
    .status-title {
      color: #67c23a;
    }
  }
}

.timeline-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 16px;
  margin-right: 12px;
  flex-shrink: 0;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 2px solid #c0c4cc;
    background: #fff;
    flex-shrink: 0;

    &.active {
      border-color: #67c23a;
      background: #67c23a;
    }
  }

  .line {
    flex: 1;
    width: 1px;
    background: #e4e7ed;
    min-height: 20px;
  }
}

.timeline-content {
  flex: 1;

  .status-title {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
    margin: 0 0 4px;
    line-height: 1.4;
  }

  .status-desc {
    font-size: 13px;
    color: #606266;
    margin: 0 0 4px;
    line-height: 1.5;
  }

  .status-time {
    font-size: 12px;
    color: #909399;
    margin: 0;
    line-height: 1.4;
  }
}

.view-more {
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
  color: #909399;
  font-size: 13px;

  span {
    margin-right: 4px;
  }

  &:hover {
    color: #67c23a;
  }
}
</style>

<style lang="less">
.express-track-dialog {
  .el-dialog__header {
    padding: 16px 20px 10px;
    border-bottom: none;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }
  }

  .el-dialog__body {
    padding: 0 20px 20px;
  }
}
</style>
